import {Injectable, Inject} from 'ng-metadata/core';
import {PrimoResponse} from '../../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {OpacService} from "../opac/opac.service";
import {FullViewService } from '../../fullView.service';
import { ViewItService } from '../almaViewit/almaViewit.service';

const get = require('lodash/get');

@Injectable()
export class AlmaOtherMembersService{

    constructor(
        @Inject('$http') private $http: angular.IHttpService,
		@Inject('restBaseURLs') private restBaseURLs,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        private opacService : OpacService,
        private fullViewService: FullViewService,
        private viewItService : ViewItService){
    }

    /**
     * Checks weather the current item has availability in other institutions in the network. This information is recieved in the PNX call. 
     * @param availabilityType Adds a check for specific resource type (Electronic / Physical) 
     */
    public isMoreAlmaInst(item: PrimoResponse.IDoc, availabilityType: string) : boolean {
        let isMoreInst = get(item, 'delivery.almaInstitutionsList' , false) &&  item.delivery.almaInstitutionsList.length > 0;
        if(!availabilityType){
            return isMoreInst;
        } else {
            return isMoreInst && this.isMoreAlmaInstRequestType(item, availabilityType);
        }
    }

    public isMoreAlmaInstRequestType(item: PrimoResponse.IDoc, availabilityType: string) : boolean{
        let availabilityStatus = this.getAvailabilityStatusByType(availabilityType);
        return item.delivery.almaInstitutionsList.map((availability) => availability.availabilityStatus).includes(availabilityStatus);
    }

    public getAvailabilityStatusByType(availabilityStatus : string){
		switch(availabilityStatus){
            case 'E':
                return 'available_online';
            case 'P':
                return 'available_in_institution';
            default:
                return undefined;
        }
    }

    /**
     * Returns the 'almaInstitutionsList' object filtered by the availability type
     * @param item The PNX response that contains the information for other institutions
     * @param availabilityType The required availability type for the filtration (E / P)
     */
    public getInstitutionsFilteredByType(item: PrimoResponse.IDoc, availabilityType: string) : PrimoResponse.IDoc.delivery.almaInstitutionsList {
        return item.delivery.almaInstitutionsList.filter((institution) => institution.availabilityStatus === this.getAvailabilityStatusByType(availabilityType)) || [];
        
    }

    public loadOtherMember(almaInst : PrimoResponse.IDoc.delivery.almaInstitutionsList, availabilityType : string){
        let url : string;
        if(availabilityType === 'P'){
            url = this.restBaseURLs.memberPnx + '/' + availabilityType + '/' + almaInst.getitLink[0].linkRecordId + '?record-institution=' + almaInst.instCode + "&lang=" + this.$translate.use();
        } else {
            url = this.restBaseURLs.memberPnx + '/' + availabilityType  + '?' +
             almaInst.getitLink.map(link => 'recordsIds=' + link.linkRecordId).join('&') +
              '&record-institution=' + almaInst.instCode + "&lang=" + this.$translate.use();
        }
        return this.$http.get(url);
    }

    // ------------------------ Getit other ----------------------------------

    public opacRequestInProgress(){
        return this.opacService.serviceListRequestInProgress;
    }

    // ------------------------ Viewit other ----------------------------------

    public getServicesList(){
        return this.viewItService.getServicesList();
	}

    /**
     * Maps the Viewit other response to services types (E / D) 
     * @param memberItem The response from 'loadOtherMember' for availability type 'E'
     */
    public initializeViewitOtherServicesMap(memberItem : PrimoResponse.IDoc) : {} {
        let servicesMap = {};
		if(memberItem){
			for(let serviceType of this.getServicesList()){
				let resultService = memberItem
					.filter((service)=> serviceType.name === service.serviceType)
					.map((service) => {
						service.parsedAvailiability = this.viewItService.splitHtml(service.availiability)
						return service;
					});
				servicesMap[serviceType.name] = resultService;
			}
        }
        return servicesMap;
	}

    public getLinkedAccountCreationOption(institution, envURL) : Promise<any>{
        let serviceData = {} as PrimoResponse.Ils.IRequestService;
        serviceData['link-to-service'] = this.restBaseURLs['ILSServicesBaseURL'] + "/linkedAccountCreationOption?record-institution=" + institution + "&envURL=" + encodeURIComponent(envURL);
        return this.opacService.makeIlsCall(serviceData);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/almaOtherMembers/almaOtherMembers.service.ts